import { Id, Json, DomainEntity } from '@homeleite/arch';
import { AnimalSummary } from '../..';

export class HerdoutSummary implements DomainEntity {
    constructor(
        public readonly id = Id.gen(),
        public animal: AnimalSummary = null,
    ) { }

    toJson() {
        return Json.to.simple(this, {
            animal: this.animal?.toJson() ?? null,
        });
    }

    static fromJson(json: HerdoutSummary) {
        return Json.from.simple(json, HerdoutSummary, {
            animal: json.animal ? AnimalSummary.fromJson(json.animal) : null,
        });
    }
}
